import React, { Component } from 'react';
import firebaseApp from 'firebase/firebase-app';
import firebase from './firebase';
import 'firebase/firestore'

const Context = React.createContext();

export class Provider extends Component {

    state = {
        sections: [],
        digitalIllustrations: [],
        lettering: [],
        popCulture: [],
        inktober2020: [],
        portraits: [],
        blackInk: [],
        paintings: [],
        mandalas: [],
        blogs: [],
    };

    componentDidMount() {
        const db = firebase.firestore();

        //References
        const refToSections = db.collection("sections").orderBy("rank");
        const refToDigitalIllustrations = db.collection("digitalIllustrations").orderBy("rank");
        const refToLettering = db.collection("lettering").orderBy("rank");
        const refToPopCulture = db.collection("popCulture").orderBy("rank");
        const refToInktober2020 = db.collection("inktober2020").orderBy("date");
        const refToPortraits = db.collection("portraits").orderBy("rank");
        const refToMandalas = db.collection("mandalas").orderBy("rank");
        const refToBlackInk = db.collection("blackInk").orderBy("rank");
        const refToPaintings = db.collection("paintings").orderBy("rank");
        const refToBlogs = db.collection("blogs").orderBy("rank");

        //Retrieving and assigning state
        refToSections.onSnapshot((querySnapshot) => {
            const items = [];
            querySnapshot.forEach((item) => {
                items.push(item.data())
            })
            this.setState({
                sections: items,
            })
        })

        refToDigitalIllustrations.onSnapshot((querySnapshot) => {
            const items = [];
            querySnapshot.forEach((item) => {
                items.push(item.data())
            })
            this.setState({
                digitalIllustrations: items,
            })
        })

        refToLettering.onSnapshot((querySnapshot) => {
            const items = [];
            querySnapshot.forEach((item) => {
                items.push(item.data())
            })
            this.setState({
                lettering: items,
            })
        })

        refToPopCulture.onSnapshot((querySnapshot) => {
            const items = [];
            querySnapshot.forEach((item) => {
                items.push(item.data())
            })
            this.setState({
                popCulture: items,
            })
        })

        refToInktober2020.onSnapshot((querySnapshot) => {
            const items = [];
            querySnapshot.forEach((item) => {
                items.push(item.data())
            })
            this.setState({
                inktober2020: items,
            })
        })

        refToPortraits.onSnapshot((querySnapshot) => {
            const items = [];
            querySnapshot.forEach((item) => {
                items.push(item.data())
            })
            this.setState({
                portraits: items,
            })
        })

        refToMandalas.onSnapshot((querySnapshot) => {
            const items = [];
            querySnapshot.forEach((item) => {
                items.push(item.data())
            })
            this.setState({
                mandalas: items,
            })
        })

        refToBlogs.onSnapshot((querySnapshot) => {
            const items = [];
            querySnapshot.forEach((item) => {
                items.push(item.data())
            })
            this.setState({
                blogs: items,
            })
        })

        refToBlackInk.onSnapshot((querySnapshot) => {
            const items = [];
            querySnapshot.forEach((item) => {
                items.push(item.data())
            })
            this.setState({
                blackInk: items,
            })
        })

        refToPaintings.onSnapshot((querySnapshot) => {
            const items = [];
            querySnapshot.forEach((item) => {
                items.push(item.data())
            })
            this.setState({
                paintings: items,
            })
        })
    }

    render() {
        return (
            <Context.Provider value={this.state}>
                {this.props.children}
            </Context.Provider>
        );
    }
}

export const Consumer = Context.Consumer;

// const collections = ["sections", "digitalIllustrations"];

        // const newState = {};

        // for (let coll in collections){
        //     const ref = db.collection(coll);
        //     ref.onSnapshot((querySnapshot) => {
        //         const items = [];
        //         querySnapshot.forEach((item) => {
        //             items.push(item.data())
        //         })
        //         newState.coll = items;
        //     })
        // }

        // this.setState(newState);